import { render, staticRenderFns } from "./SettingsBackgroundColor.vue?vue&type=template&id=330fa9ab&"
import script from "./SettingsBackgroundColor.vue?vue&type=script&lang=js&"
export * from "./SettingsBackgroundColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports